var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _g, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _g2, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHyperCoinGemStack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 121,
    viewBox: "0 0 255 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.764 76.7002C100.825 67.8438 87.5196 60.515 71.0464 60.3309C54.5732 60.1468 41.1701 67.177 41.1098 76.0334C41.0494 84.8898 54.3547 92.2186 70.8278 92.4027C87.301 92.5868 100.704 85.5566 100.764 76.7002Z",
    fill: "#FF7C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.836 64.721L41.2202 64.0547L41.1355 76.4846L100.751 77.1509L100.836 64.721Z",
    fill: "#FF7C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0928 64.0615L41.0115 76.1488C41.0115 76.1488 40.6504 83.5477 52.0811 88.6341L52.5355 75.6379C52.5355 75.6379 42.948 71.1423 41.0935 64.0623L41.0928 64.0615Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_424_207912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 60,
    width: 60,
    height: 33
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.667 76.7909C100.729 67.9345 87.4256 60.6104 70.9524 60.4319C54.4791 60.2535 41.0745 67.2884 41.0122 76.1448C40.9499 85.0012 54.2536 92.3253 70.7268 92.5037C87.2001 92.6821 100.605 85.6472 100.667 76.7909Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_424_207912)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1174 67.4112L68.124 67.333L67.933 95.3638L74.9264 95.4419L75.1174 67.4112Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1385 67.2105L77.6514 67.0273L77.4592 95.0581L93.9464 95.2413L94.1385 67.2105Z",
    fill: "white"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.826 64.7227C100.883 56.2822 87.5573 49.2903 71.0614 49.1059C54.5656 48.9215 41.1465 55.6145 41.089 64.055C41.0315 72.4955 54.3574 79.4874 70.8532 79.6717C87.349 79.8561 100.768 73.1632 100.826 64.7227Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M71.0749 78.9402C54.7686 78.757 41.5609 71.9215 41.3151 63.6123C41.3063 63.756 41.3013 63.9004 41.3 64.0457C41.242 72.4865 54.5676 79.4793 71.0636 79.6642C87.5596 79.8498 100.979 73.1572 101.036 64.7172C101.037 64.6204 101.035 64.5235 101.033 64.4267C100.528 72.6617 87.2873 79.1226 71.0749 78.9402Z",
    fill: "url(#paint0_linear_424_207912)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9412 63.7958C91.978 58.4041 82.6462 53.9287 71.0982 53.7996C59.5502 53.6705 50.1589 57.9367 50.1222 63.3284C50.0854 68.72 59.4172 73.1955 70.9652 73.3245C82.5132 73.4536 91.9045 69.1874 91.9412 63.7958Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M71.0374 53.776C82.2891 53.9027 91.4354 58.1554 91.8626 63.3605C91.8758 63.2241 91.8847 63.0869 91.8853 62.948C91.9225 57.5565 82.5909 53.0811 71.043 52.9511C59.4952 52.8212 50.1037 57.0868 50.0666 62.4783C50.0653 62.6163 50.0722 62.7543 50.0836 62.8907C50.5827 57.6962 59.785 53.6493 71.0374 53.776Z",
    fill: "url(#paint1_linear_424_207912)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1699 55.1784C81.942 55.2994 90.7839 59.2026 91.8936 64.1026C91.9006 64.0025 91.9056 63.9024 91.9063 63.8016C91.9434 58.41 82.6119 53.9346 71.064 53.8046C59.5161 53.6747 50.1247 57.9403 50.0875 63.3318C50.085 63.6942 50.126 64.0518 50.206 64.4053C50.5828 59.1574 59.8375 55.0516 71.1692 55.1792L71.1699 55.1784Z",
    fill: "#CB6300"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6348 56.8602L63.8531 56.8359L63.8386 61.5285L68.6203 61.5527L68.6348 56.8602ZM68.6348 56.8602L63.8531 56.8359L63.8386 61.5285L68.6203 61.5527L68.6348 56.8602ZM68.6058 66.2477L63.8241 66.2235L63.8096 70.916L68.5913 70.9402L68.6058 66.2477ZM68.6058 66.2477L63.8241 66.2235L63.8096 70.916L68.5913 70.9402L68.6058 66.2477ZM68.6222 61.5527L68.6077 66.2453L73.3894 66.2695L73.3749 70.9636L78.1567 70.9879L78.1712 66.2937L78.1856 61.6011L73.4039 61.5769L68.6222 61.5527ZM68.6222 61.5527L68.6077 66.2453L73.3894 66.2695L73.3749 70.9636L78.1567 70.9879L78.1712 66.2937L78.1856 61.6011L73.4039 61.5769L68.6222 61.5527Z",
    fill: "#C15900"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M100.934 64.7208H100.929C100.987 56.2801 87.6616 49.2872 71.1656 49.1024C54.6697 48.9168 41.2502 55.6093 41.1928 64.0493C41.1897 64.5247 41.2294 64.9953 41.3088 65.4602L41.2458 74.6653C41.1601 75.1495 41.1147 75.6403 41.1115 76.1366C41.051 84.9931 54.3558 92.3225 70.8291 92.5081C82.7116 92.6421 92.9966 89.0214 97.8288 83.6694C99.7577 81.575 100.848 79.2101 100.865 76.6992C100.866 76.5418 100.862 76.3844 100.855 76.2287L100.934 64.7216V64.7208Z",
    stroke: "#771B00",
    strokeWidth: 2.51436,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.224 60.7012C101.284 51.8448 87.979 44.516 71.5058 44.3319C55.0327 44.1478 41.6296 51.178 41.5692 60.0344C41.5089 68.8908 54.8141 76.2196 71.2873 76.4037C87.7605 76.5878 101.164 69.5576 101.224 60.7012Z",
    fill: "#FF7C00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.299 48.7269L41.6836 48.0605L41.5989 60.4904L101.215 61.1568L101.299 48.7269Z",
    fill: "#FF7C00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5542 48.0605L41.473 60.1479C41.473 60.1479 41.1119 67.5467 52.5425 72.6331L52.9969 59.637C52.9969 59.637 43.4095 55.1413 41.5549 48.0614L41.5542 48.0605Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_424_207912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 44,
    width: 61,
    height: 33
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.132 60.7928C101.194 51.9364 87.8905 44.6123 71.4172 44.4339C54.944 44.2555 41.5393 51.2904 41.477 60.1467C41.4147 69.0031 54.7185 76.3272 71.1917 76.5057C87.6649 76.6841 101.07 69.6492 101.132 60.7928Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_424_207912)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5827 51.419L68.5894 51.3408L68.3984 79.3716L75.3917 79.4498L75.5827 51.419Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6029 51.2174L78.1157 51.0342L77.9236 79.0649L94.4108 79.2481L94.6029 51.2174Z",
    fill: "white"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M101.291 48.7276C101.349 40.287 88.0231 33.2952 71.5273 33.1108C55.0315 32.9264 41.6123 39.6193 41.5548 48.0599C41.4973 56.5004 54.8232 63.4922 71.319 63.6766C87.8148 63.861 101.234 57.1681 101.291 48.7276Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M71.5373 62.9451C55.231 62.7619 42.0233 55.9264 41.7775 47.6172C41.7687 47.7609 41.7637 47.9053 41.7624 48.0506C41.7044 56.4914 55.03 63.4842 71.526 63.669C88.022 63.8547 101.441 57.1621 101.499 48.7221C101.499 48.6253 101.498 48.5284 101.495 48.4316C100.99 56.6665 87.7497 63.1275 71.5373 62.9451Z",
    fill: "url(#paint2_linear_424_207912)"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4061 47.8016C92.4428 42.41 83.1111 37.9345 71.5631 37.8055C60.0151 37.6764 50.6238 41.9426 50.587 47.3342C50.5503 52.7259 59.882 57.2013 71.43 57.3304C82.978 57.4595 92.3693 53.1933 92.4061 47.8016Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M71.5032 37.778C82.7549 37.9047 91.9012 42.1573 92.3284 47.3624C92.3417 47.226 92.3505 47.0888 92.3511 46.95C92.3883 41.5585 83.0567 37.083 71.5089 36.9531C59.961 36.8231 50.5696 41.0887 50.5324 46.4802C50.5311 46.6183 50.538 46.7563 50.5494 46.8927C51.0485 41.6981 60.2509 37.6512 71.5032 37.778Z",
    fill: "url(#paint3_linear_424_207912)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6318 39.1793C82.4039 39.3004 91.2458 43.2036 92.3556 48.1036C92.3625 48.0035 92.3675 47.9034 92.3682 47.8025C92.4053 42.411 83.0738 37.9356 71.5259 37.8056C59.978 37.6757 50.5866 41.9413 50.5494 47.3328C50.5469 47.6952 50.5879 48.0527 50.6679 48.4062C51.0447 43.1584 60.2994 39.0526 71.6311 39.1801L71.6318 39.1793Z",
    fill: "#CB6300"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0952 40.8641L64.3135 40.8398L64.299 45.5324L69.0807 45.5566L69.0952 40.8641ZM69.0952 40.8641L64.3135 40.8398L64.299 45.5324L69.0807 45.5566L69.0952 40.8641ZM69.0662 50.2516L64.2845 50.2274L64.27 54.9199L69.0517 54.9441L69.0662 50.2516ZM69.0662 50.2516L64.2845 50.2274L64.27 54.9199L69.0517 54.9441L69.0662 50.2516ZM69.0826 45.5566L69.0681 50.2492L73.8499 50.2734L73.8354 54.9676L78.6171 54.9918L78.6316 50.2976L78.6461 45.605L73.8644 45.5808L69.0826 45.5566ZM69.0826 45.5566L69.0681 50.2492L73.8499 50.2734L73.8354 54.9676L78.6171 54.9918L78.6316 50.2976L78.6461 45.605L73.8644 45.5808L69.0826 45.5566Z",
    fill: "#C15900"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M101.393 48.7277H101.389C101.447 40.2869 88.1211 33.2941 71.6251 33.1092C55.1291 32.9236 41.7096 39.6162 41.6523 48.0562C41.6491 48.5315 41.6888 49.0021 41.7682 49.467L41.7052 58.6721C41.6195 59.1564 41.5742 59.6471 41.571 60.1435C41.5105 68.9999 54.8153 76.3293 71.2886 76.515C83.1711 76.6489 93.4561 73.0282 98.2882 67.6763C100.217 65.5818 101.307 63.217 101.324 60.706C101.326 60.5487 101.322 60.3913 101.314 60.2355L101.393 48.7285V48.7277Z",
    stroke: "#771B00",
    strokeWidth: 2.51436,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108.228 44.5166C108.288 35.6602 94.9829 28.3314 78.5097 28.1473C62.0366 27.9632 48.6335 34.9934 48.5731 43.8498C48.5128 52.7062 61.818 60.035 78.2912 60.2191C94.7644 60.4033 108.167 53.373 108.228 44.5166Z",
    fill: "#FF7C00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M108.303 32.5384L48.687 31.8721L48.6023 44.3019L108.218 44.9683L108.303 32.5384Z",
    fill: "#FF7C00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5621 31.8721L48.4808 43.9594C48.4808 43.9594 48.1197 51.3582 59.5503 56.4446L60.0047 43.4485C60.0047 43.4485 50.4173 38.9529 48.5627 31.8729L48.5621 31.8721Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_424_207912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 28,
    width: 61,
    height: 33
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M108.137 44.6082C108.199 35.7519 94.8953 28.4277 78.4221 28.2493C61.9489 28.0709 48.5442 35.1058 48.4819 43.9622C48.4196 52.8185 61.7233 60.1427 78.1966 60.3211C94.6698 60.4995 108.074 53.4646 108.137 44.6082Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_424_207912)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5827 35.2305L75.5894 35.1523L75.3984 63.1831L82.3917 63.2613L82.5827 35.2305Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M101.604 35.0299L85.1167 34.8467L84.9246 62.8774L101.412 63.0606L101.604 35.0299Z",
    fill: "white"
  })))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108.291 32.5391C108.349 24.0986 95.0231 17.1067 78.5273 16.9223C62.0314 16.738 48.6123 23.4309 48.5548 31.8714C48.4973 40.3119 61.8232 47.3038 78.319 47.4881C94.8148 47.6725 108.234 40.9796 108.291 32.5391Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M78.5407 46.7566C62.2344 46.5734 49.0267 39.7379 48.7809 31.4287C48.7721 31.5724 48.7671 31.7169 48.7658 31.8621C48.7078 40.3029 62.0334 47.2957 78.5294 47.4806C95.0254 47.6662 108.445 40.9736 108.502 32.5336C108.503 32.4368 108.501 32.3399 108.498 32.2431C107.994 40.4781 94.7531 46.939 78.5407 46.7566Z",
    fill: "url(#paint4_linear_424_207912)"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4085 31.6132C99.4452 26.2215 90.1135 21.7461 78.5655 21.617C67.0175 21.4879 57.6262 25.7541 57.5895 31.1457C57.5527 36.5374 66.8845 41.0128 78.4325 41.1419C89.9805 41.271 99.3718 37.0048 99.4085 31.6132Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M78.5012 21.5934C89.7529 21.7201 98.8992 25.9728 99.3265 31.1779C99.3397 31.0414 99.3485 30.9042 99.3492 30.7654C99.3863 25.3739 90.0548 20.8985 78.5069 20.7685C66.959 20.6386 57.5676 24.9042 57.5304 30.2957C57.5292 30.4337 57.5361 30.5717 57.5474 30.7081C58.0465 25.5135 67.2489 21.4667 78.5012 21.5934Z",
    fill: "url(#paint5_linear_424_207912)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6396 22.9918C89.4117 23.1129 98.2536 27.0161 99.3634 31.9161C99.3703 31.816 99.3754 31.7159 99.376 31.615C99.4132 26.2235 90.0816 21.7481 78.5337 21.6181C66.9858 21.4882 57.5944 25.7538 57.5572 31.1453C57.5547 31.5077 57.5957 31.8652 57.6757 32.2187C58.0526 26.9709 67.3072 22.8651 78.639 22.9926L78.6396 22.9918Z",
    fill: "#CB6300"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1016 24.6775L71.3199 24.6533L71.3054 29.3459L76.0871 29.3701L76.1016 24.6775ZM76.1016 24.6775L71.3199 24.6533L71.3054 29.3459L76.0871 29.3701L76.1016 24.6775ZM76.0726 34.0651L71.2909 34.0409L71.2764 38.7334L76.0581 38.7576L76.0726 34.0651ZM76.0726 34.0651L71.2909 34.0409L71.2764 38.7334L76.0581 38.7576L76.0726 34.0651ZM76.089 29.3701L76.0745 34.0626L80.8562 34.0869L80.8417 38.781L85.6235 38.8052L85.638 34.1111L85.6524 29.4185L80.8707 29.3943L76.089 29.3701ZM76.089 29.3701L76.0745 34.0626L80.8562 34.0869L80.8417 38.781L85.6235 38.8052L85.638 34.1111L85.6524 29.4185L80.8707 29.3943L76.089 29.3701Z",
    fill: "#C15900"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M108.399 32.5431H108.395C108.453 24.1023 95.1269 17.1095 78.631 16.9247C62.135 16.739 48.7155 23.4316 48.6582 31.8716C48.655 32.347 48.6947 32.8175 48.7741 33.2824L48.7111 42.4875C48.6254 42.9718 48.58 43.4625 48.5769 43.9589C48.5164 52.8154 61.8212 60.1447 78.2944 60.3304C90.1769 60.4644 100.462 56.8437 105.294 51.4917C107.223 49.3972 108.313 47.0324 108.33 44.5215C108.332 44.3641 108.328 44.2067 108.32 44.0509L108.399 32.5439V32.5431Z",
    stroke: "#771B00",
    strokeWidth: 2.51436,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M103.199 28.9277C103.259 20.0714 89.9536 12.7426 73.4804 12.5584C57.0073 12.3743 43.6042 19.4046 43.5438 28.261C43.4835 37.1174 56.7887 44.4461 73.2619 44.6303C89.7351 44.8144 103.138 37.7841 103.199 28.9277Z",
    fill: "#FF7C00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M103.271 16.9495L43.6553 16.2832L43.5706 28.7131L103.186 29.3794L103.271 16.9495Z",
    fill: "#FF7C00"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5298 16.2832L43.4485 28.3705C43.4485 28.3705 43.0875 35.7693 54.5181 40.8557L54.9725 27.8596C54.9725 27.8596 45.3851 23.364 43.5305 16.284L43.5298 16.2832Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_424_207912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 12,
    width: 61,
    height: 33
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M103.101 29.0077C103.163 20.1513 89.8597 12.8271 73.3865 12.6487C56.9132 12.4703 43.5085 19.5052 43.4463 28.3616C43.384 37.218 56.6877 44.5421 73.1609 44.7205C89.6342 44.8989 103.039 37.864 103.101 29.0077Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_424_207912)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5481 19.6338L70.5547 19.5557L70.3637 47.5864L77.3571 47.6646L77.5481 19.6338Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5712 19.4322L80.084 19.249L79.8919 47.2798L96.379 47.463L96.5712 19.4322Z",
    fill: "white"
  })))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M103.26 16.9502C103.318 8.5097 89.9918 1.51785 73.496 1.33347C57.0002 1.14909 43.5811 7.84201 43.5236 16.2825C43.4661 24.723 56.7919 31.7149 73.2877 31.8993C89.7836 32.0837 103.203 25.3907 103.26 16.9502Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M73.508 31.1638C57.2017 30.9806 43.994 24.1452 43.7482 15.8359C43.7394 15.9796 43.7344 16.1241 43.7331 16.2694C43.6751 24.7101 57.0007 31.703 73.4967 31.8878C89.9926 32.0734 103.412 25.3809 103.469 16.9409C103.47 16.844 103.468 16.7472 103.466 16.6503C102.961 24.8853 89.7204 31.3462 73.508 31.1638Z",
    fill: "url(#paint6_linear_424_207912)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3787 16.0214C94.4155 10.6297 85.0837 6.15426 73.5357 6.02518C61.9877 5.89611 52.5964 10.1623 52.5597 15.5539C52.5229 20.9456 61.8547 25.421 73.4027 25.5501C84.9507 25.6792 94.342 21.413 94.3787 16.0214Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M73.4724 6.00452C84.7241 6.13124 93.8704 10.3839 94.2977 15.589C94.3109 15.4526 94.3197 15.3154 94.3204 15.1765C94.3575 9.78504 85.026 5.30959 73.4781 5.17965C61.9302 5.0497 52.5388 9.3153 52.5016 14.7068C52.5004 14.8448 52.5073 14.9828 52.5186 15.1192C53.0177 9.92467 62.2201 5.8778 73.4724 6.00452Z",
    fill: "url(#paint7_linear_424_207912)"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6069 7.39906C84.379 7.52013 93.2209 11.4233 94.3307 16.3233C94.3376 16.2232 94.3426 16.1231 94.3433 16.0223C94.3804 10.6307 85.0489 6.1553 73.501 6.02535C61.9531 5.89541 52.5617 10.161 52.5245 15.5525C52.522 15.9149 52.563 16.2725 52.643 16.626C53.0198 11.3781 62.2745 7.27234 73.6062 7.39987L73.6069 7.39906Z",
    fill: "#CB6300"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1917 8.67456L65.4741 8.64551L65.4597 13.3381L71.1772 13.3671L71.1917 8.67456ZM71.1917 8.67456L65.4741 8.64551L65.4597 13.3381L71.1772 13.3671L71.1917 8.67456ZM71.1627 18.0621L65.4452 18.033L65.4307 22.7256L71.1482 22.7546L71.1627 18.0621ZM71.1627 18.0621L65.4452 18.033L65.4307 22.7256L71.1482 22.7546L71.1627 18.0621ZM71.1797 13.3671L71.1652 18.0597L76.8828 18.0887L76.8683 22.7829L82.5858 22.812L82.6003 18.1178L82.6148 13.4252L76.8972 13.3962L71.1797 13.3671ZM71.1797 13.3671L71.1652 18.0597L76.8828 18.0887L76.8683 22.7829L82.5858 22.812L82.6003 18.1178L82.6148 13.4252L76.8972 13.3962L71.1797 13.3671Z",
    fill: "#C15900"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M103.37 16.9494H103.366C103.424 8.50857 90.0981 1.51575 73.6021 1.33092C57.1062 1.14528 43.6867 7.83786 43.6294 16.2778C43.6262 16.7532 43.6659 17.2238 43.7453 17.6887L43.6823 26.8938C43.5966 27.3781 43.5512 27.8688 43.5481 28.3652C43.4876 37.2216 56.7924 44.551 73.2656 44.7366C85.1481 44.8706 95.4331 41.2499 100.265 35.8979C102.194 33.8035 103.284 31.4386 103.301 28.9277C103.303 28.7703 103.299 28.6129 103.291 28.4572L103.37 16.9502V16.9494Z",
    stroke: "#771B00",
    strokeWidth: 2.51436,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6507 92.2607C70.711 83.4044 57.4058 76.0756 40.9326 75.8914C24.4594 75.7073 11.0563 82.7376 10.996 91.594C10.9356 100.45 24.2409 107.779 40.7141 107.963C57.1873 108.147 70.5903 101.117 70.6507 92.2607Z",
    fill: "#FF7C00"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7236 80.2816L11.1079 79.6152L11.0232 92.0451L70.6389 92.7114L70.7236 80.2816Z",
    fill: "#FF7C00"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9781 79.6152L10.8968 91.7026C10.8968 91.7026 10.5357 99.1014 21.9664 104.188L22.4207 91.1917C22.4207 91.1917 12.8333 86.696 10.9787 79.616L10.9781 79.6152Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_424_207912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 75,
    width: 61,
    height: 34
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5533 92.3387C70.6155 83.4823 57.3118 76.1582 40.8386 75.9798C24.3654 75.8014 10.9607 82.8363 10.8984 91.6926C10.8361 100.549 24.1398 107.873 40.6131 108.052C57.0863 108.23 70.491 101.195 70.5533 92.3387Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_424_207912)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0051 82.9707L38.0117 82.8926L37.8207 110.923L44.8141 111.002L45.0051 82.9707Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0267 82.7691L47.5396 82.5859L47.3474 110.617L63.8346 110.8L64.0267 82.7691Z",
    fill: "white"
  })))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7148 80.2793C70.7723 71.8388 57.4464 64.8469 40.9506 64.6626C24.4548 64.4782 11.0357 71.1711 10.9782 79.6116C10.9206 88.0521 24.2465 95.044 40.7423 95.2284C57.2382 95.4128 70.6573 88.7198 70.7148 80.2793Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M40.9616 94.5027C24.6553 94.3195 11.4476 87.484 11.2018 79.1748C11.193 79.3185 11.188 79.4629 11.1867 79.6082C11.1287 88.049 24.4543 95.0418 40.9503 95.2267C57.4463 95.4123 70.8657 88.7197 70.9231 80.2797C70.9237 80.1829 70.9218 80.086 70.9193 79.9892C70.4145 88.2242 57.174 94.6851 40.9616 94.5027Z",
    fill: "url(#paint8_linear_424_207912)"
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8309 79.3534C61.8676 73.9617 52.5359 69.4863 40.9879 69.3572C29.4399 69.2281 20.0486 73.4943 20.0118 78.886C19.9751 84.2776 29.3068 88.7531 40.8548 88.8821C52.4028 89.0112 61.7941 84.7451 61.8309 79.3534Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M40.9236 69.3405C52.1753 69.4672 61.3216 73.7198 61.7488 78.9249C61.7621 78.7885 61.7709 78.6513 61.7715 78.5125C61.8087 73.121 52.4771 68.6455 40.9293 68.5156C29.3814 68.3856 19.99 72.6512 19.9528 78.0427C19.9515 78.1808 19.9585 78.3188 19.9698 78.4552C20.4689 73.2606 29.6713 69.2137 40.9236 69.3405Z",
    fill: "url(#paint9_linear_424_207912)"
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0546 70.735C51.8268 70.8561 60.6687 74.7593 61.7784 79.6592C61.7853 79.5592 61.7904 79.4591 61.791 79.3582C61.8282 73.9667 52.4966 69.4912 40.9488 69.3613C29.4009 69.2313 20.0095 73.4969 19.9723 78.8884C19.9698 79.2508 20.0107 79.6084 20.0908 79.9619C20.4676 74.7141 29.7223 70.6083 41.054 70.7358L41.0546 70.735Z",
    fill: "#CB6300"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6438 72.0076L32.9263 71.9785L32.9118 76.6711L38.6293 76.7001L38.6438 72.0076ZM38.6438 72.0076L32.9263 71.9785L32.9118 76.6711L38.6293 76.7001L38.6438 72.0076ZM38.6148 81.3951L32.8973 81.366L32.8828 86.0586L38.6004 86.0877L38.6148 81.3951ZM38.6148 81.3951L32.8973 81.366L32.8828 86.0586L38.6004 86.0877L38.6148 81.3951ZM38.6319 76.7001L38.6174 81.3927L44.3349 81.4217L44.3204 86.1159L50.0379 86.145L50.0524 81.4508L50.0669 76.7582L44.3494 76.7292L38.6319 76.7001ZM38.6319 76.7001L38.6174 81.3927L44.3349 81.4217L44.3204 86.1159L50.0379 86.145L50.0524 81.4508L50.0669 76.7582L44.3494 76.7292L38.6319 76.7001Z",
    fill: "#C15900"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8223 80.2862H70.8179C70.8759 71.8455 57.5503 64.8526 41.0543 64.6678C24.5583 64.483 11.1388 71.1747 11.0815 79.6147C11.0783 80.0901 11.118 80.5607 11.1974 81.0256L11.1344 90.2307C11.0487 90.7149 11.0034 91.2057 11.0002 91.702C10.9397 100.558 24.2445 107.888 40.7178 108.074C52.6003 108.208 62.8853 104.587 67.7174 99.2348C69.6464 97.1404 70.7366 94.7755 70.7536 92.2646C70.7549 92.1072 70.7511 91.9498 70.7435 91.7941L70.8223 80.2871V80.2862Z",
    stroke: "#771B00",
    strokeWidth: 2.51436,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8594 76.2946C61.9202 67.4382 48.6152 60.1104 32.142 59.9274C15.6688 59.7445 2.26542 66.7757 2.20469 75.6321C2.14396 84.4884 15.4489 91.8163 31.9221 91.9992C48.3953 92.1822 61.7987 85.151 61.8594 76.2946Z",
    fill: "#FF7C00"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9345 64.3236L2.31885 63.6572L2.23415 76.0871L61.8498 76.7534L61.9345 64.3236Z",
    fill: "#FF7C00"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19048 63.6543L2.10919 75.7416C2.10919 75.7416 1.7481 83.1404 13.1788 88.2268L13.6331 75.2307C13.6331 75.2307 4.0457 70.7351 2.19111 63.6551L2.19048 63.6543Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_424_207912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 60,
    width: 60,
    height: 33
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7676 76.3895C61.8299 67.5331 48.5262 60.209 32.053 60.0306C15.5797 59.8522 2.17504 66.8871 2.11277 75.7434C2.05049 84.5998 15.3542 91.9239 31.8274 92.1023C48.3007 92.2807 61.7054 85.2459 61.7676 76.3895Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_424_207912)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M36.218 67.0157L29.2246 66.9375L29.0336 94.9683L36.027 95.0464L36.218 67.0157Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2386 66.8141L38.7515 66.6309L38.5593 94.6616L55.0465 94.8448L55.2386 66.8141Z",
    fill: "white"
  })))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9243 64.3213C61.9818 55.8808 48.6559 48.8889 32.1601 48.7046C15.6643 48.5202 2.24514 55.2131 2.18763 63.6536C2.13012 72.0941 15.456 79.086 31.9518 79.2704C48.4476 79.4547 61.8667 72.7618 61.9243 64.3213Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M32.1701 78.5417C15.8638 78.3585 2.6561 71.5231 2.41033 63.2139C2.40151 63.3575 2.39647 63.502 2.39521 63.6473C2.33723 72.0881 15.6628 79.0809 32.1588 79.2657C48.6548 79.4514 62.0742 72.7588 62.1316 64.3188C62.1322 64.222 62.1303 64.1251 62.1278 64.0282C61.623 72.2632 48.3825 78.7242 32.1701 78.5417Z",
    fill: "url(#paint10_linear_424_207912)"
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0418 63.3954C53.0785 58.0037 43.7468 53.5283 32.1988 53.3992C20.6508 53.2701 11.2595 57.5363 11.2228 62.928C11.186 68.3196 20.5178 72.7951 32.0658 72.9241C43.6138 73.0532 53.0051 68.787 53.0418 63.3954Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M32.135 53.3756C43.3867 53.5023 52.533 57.755 52.9603 62.9601C52.9735 62.8237 52.9823 62.6865 52.983 62.5476C53.0201 57.1561 43.6886 52.6807 32.1407 52.5507C20.5928 52.4208 11.2014 56.6864 11.1642 62.0779C11.1629 62.2159 11.1699 62.3539 11.1812 62.4903C11.6803 57.2958 20.8827 53.2489 32.135 53.3756Z",
    fill: "url(#paint11_linear_424_207912)"
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2651 54.7741C43.0372 54.8951 51.8791 58.7983 52.9889 63.6983C52.9958 63.5982 53.0008 63.4981 53.0015 63.3973C53.0386 58.0057 43.7071 53.5303 32.1592 53.4004C20.6113 53.2704 11.2199 57.536 11.1827 62.9275C11.1802 63.2899 11.2212 63.6475 11.3012 64.001C11.678 58.7531 20.9327 54.6473 32.2644 54.7749L32.2651 54.7741Z",
    fill: "#CB6300"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8528 56.0525L24.1353 56.0234L24.1208 60.716L29.8383 60.745L29.8528 56.0525ZM29.8528 56.0525L24.1353 56.0234L24.1208 60.716L29.8383 60.745L29.8528 56.0525ZM29.8238 65.44L24.1063 65.411L24.0918 70.1035L29.8093 70.1326L29.8238 65.44ZM29.8238 65.44L24.1063 65.411L24.0918 70.1035L29.8093 70.1326L29.8238 65.44ZM29.8408 60.745L29.8263 65.4376L35.5439 65.4667L35.5294 70.1608L41.2469 70.1899L41.2614 65.4957L41.2759 60.8032L35.5584 60.7741L29.8408 60.745ZM29.8408 60.745L29.8263 65.4376L35.5439 65.4667L35.5294 70.1608L41.2469 70.1899L41.2614 65.4957L41.2759 60.8032L35.5584 60.7741L29.8408 60.745Z",
    fill: "#C15900"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0293 64.3263H62.0249C62.0829 55.8855 48.7573 48.8927 32.2613 48.7079C15.7654 48.5222 2.34587 55.2148 2.28853 63.6548C2.28538 64.1302 2.32508 64.6007 2.40448 65.0656L2.34146 74.2707C2.25576 74.755 2.21039 75.2457 2.20724 75.7421C2.14674 84.5986 15.4515 91.9279 31.9248 92.1136C43.8073 92.2476 54.0923 88.6269 58.9245 83.2749C60.8534 81.1804 61.9436 78.8156 61.9606 76.3047C61.9619 76.1473 61.9581 75.9899 61.9506 75.8341L62.0293 64.3271V64.3263Z",
    stroke: "#771B00",
    strokeWidth: 2.51436,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M56.842 35.8115C56.842 29.1762 56.455 28.6806 51.2744 28.6806C56.455 28.6806 56.842 28.1851 56.842 21.5498C56.842 28.1851 57.2289 28.6806 62.4095 28.6806C57.2289 28.6806 56.842 29.1762 56.842 35.8115Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M115.358 99.3249C112.791 99.5969 110.224 99.8689 107.658 100.142C101.516 100.792 95.1489 96.856 90.5757 88.5677C82.7963 74.4675 83.1548 53.1105 91.376 40.8666C94.7651 35.8189 98.9601 33.1078 103.267 32.6518L110.968 31.835C106.661 32.2918 102.466 35.0021 99.0767 40.0498C90.8549 52.2961 90.497 73.6515 98.2764 87.7517C102.85 96.0408 109.216 99.9771 115.358 99.3249Z",
    fill: "#FF7C00"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M127.252 91.1116C119.029 103.357 106.059 101.853 98.2791 87.7524C90.4996 73.6529 90.8576 52.2967 99.0794 40.0504C107.301 27.8057 120.273 29.3093 128.052 43.4096C135.832 57.5099 135.473 78.8669 127.252 91.1116Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M123.527 83.5269C117.62 92.3236 108.302 91.247 102.71 81.1137C97.1219 70.9852 97.379 55.6388 103.286 46.842C109.194 38.0421 118.513 39.126 124.101 49.2545C129.692 59.3886 129.434 74.7262 123.527 83.5269Z",
    fill: "url(#paint12_linear_424_207912)"
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M123.286 83.9233C117.38 92.72 108.061 91.6449 102.47 81.5108C96.882 71.3815 97.1384 56.0351 103.046 47.2384C108.954 38.4384 118.272 39.5224 123.861 49.6524C129.452 59.7849 129.194 75.1241 123.287 83.9241L123.286 83.9233Z",
    fill: "#FF9600"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M121.911 50.8796C127.502 61.0129 127.244 76.3513 121.335 85.1521C120.296 86.7001 119.148 87.9366 117.936 88.8777C119.872 87.9229 121.7 86.282 123.283 83.9244C129.191 75.1245 129.449 59.7861 123.857 49.6528C119.253 41.3057 112.117 39.1079 106.441 43.5139C111.729 40.9045 117.819 43.4655 121.91 50.8804L121.911 50.8796Z",
    fill: "#CB6300"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M110.398 50.0977L104.806 50.5069L105.2 59.3286L110.792 58.9194L110.398 50.0977ZM110.398 50.0977L104.806 50.5069L105.2 59.3286L110.792 58.9194L110.398 50.0977ZM111.186 67.7452L105.594 68.1544L105.988 76.9761L111.58 76.5669L111.186 67.7452ZM111.186 67.7452L105.594 68.1544L105.988 76.9761L111.58 76.5669L111.186 67.7452ZM110.794 58.9186L111.188 67.7403L116.78 67.3311L117.174 76.1561L122.766 75.7469L122.372 66.9219L121.978 58.1002L116.386 58.5094L110.794 58.9186ZM110.794 58.9186L111.188 67.7403L116.78 67.3311L117.174 76.1561L122.766 75.7469L122.372 66.9219L121.978 58.1002L116.386 58.5094L110.794 58.9186Z",
    fill: "#C15900"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M97.8653 87.7914C102.496 96.1829 108.965 100.111 115.177 99.3363C109.091 99.8932 102.803 95.9602 98.2749 87.7518C90.4955 73.6524 90.8534 52.2962 99.0752 40.0498C102.411 35.082 106.528 32.3831 110.764 31.8633C110.673 31.8722 110.583 31.8754 110.493 31.8843L110.317 31.9036C106.096 32.4339 101.992 35.1353 98.6669 40.0894C90.4444 52.3349 90.0865 73.6903 97.8659 87.7914H97.8653Z",
    fill: "url(#paint13_linear_424_207912)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_424_207912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 31,
    width: 31,
    height: 70
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M111.504 31.8193C108.933 32.026 106.363 32.2334 103.792 32.4392C97.6412 32.9348 91.7863 38.0107 88.1981 47.0592C82.0943 62.4533 84.8645 83.519 94.3832 94.1099C98.3073 98.4756 102.765 100.38 107.077 100.032L114.789 99.4126C110.477 99.7589 106.019 97.8557 102.095 93.49C92.5746 82.8983 89.8063 61.8334 95.9095 46.4394C99.4971 37.3892 105.352 32.3141 111.503 31.8193H111.504Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_424_207912)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M111.292 52.8878L76.0073 56.2461L77.1214 75.4476L112.406 72.0893L111.292 52.8878Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M111.606 41.0343L76.3218 44.3926L76.8134 52.8657L112.098 49.5074L111.606 41.0343Z",
    fill: "white"
  })))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M107.773 99.8988C110.313 99.6284 112.852 99.3596 115.392 99.0901C119.65 98.6671 123.805 96.0416 127.183 91.1343C127.244 91.0464 127.305 90.9568 127.365 90.8672C127.441 90.7526 127.518 90.6372 127.593 90.5209C127.615 90.4886 127.636 90.4556 127.657 90.4225C127.718 90.328 127.778 90.2328 127.838 90.1376C127.853 90.115 127.867 90.0924 127.881 90.069C135.519 77.8388 135.774 57.3881 128.396 43.5914C128.394 43.5865 128.391 43.5817 128.389 43.5776C128.315 43.4396 128.241 43.3024 128.165 43.1652C128.075 43.003 127.985 42.8424 127.894 42.6834C127.878 42.6559 127.862 42.6277 127.846 42.6002C127.753 42.4396 127.661 42.2806 127.567 42.124C127.562 42.1168 127.558 42.1095 127.554 42.1014C123.85 35.9044 119.098 32.3878 114.271 31.663L114.268 31.5468C113.203 31.4249 112.137 31.4411 111.078 31.592L110.647 31.638C110.635 31.6388 110.622 31.6396 110.61 31.6412L110.434 31.6606C110.429 31.6606 110.424 31.6622 110.418 31.663L103.382 32.4096C100.38 32.7276 97.4321 34.1425 94.7734 36.6801C94.7709 36.6825 94.769 36.6841 94.7665 36.6865C94.6556 36.7922 94.5447 36.9004 94.435 37.0102C94.425 37.0207 94.4142 37.0311 94.4042 37.0416C94.3021 37.1441 94.2 37.2483 94.0985 37.3548C94.0803 37.3734 94.0626 37.3935 94.0443 37.4121C93.9504 37.5114 93.8566 37.6115 93.7633 37.7132C93.7375 37.7414 93.7122 37.7705 93.6864 37.7987C93.6007 37.894 93.515 37.9892 93.4299 38.086C93.3972 38.1232 93.365 38.1619 93.3322 38.1998C93.2547 38.2902 93.1766 38.3806 93.0997 38.4727C93.06 38.5203 93.0203 38.5695 92.9812 38.6171C92.9113 38.7019 92.8413 38.7866 92.772 38.8738C92.7248 38.9327 92.6781 38.9932 92.6315 39.053C92.5697 39.1313 92.508 39.2095 92.4469 39.2894C92.392 39.3613 92.3372 39.4355 92.2824 39.509C92.2301 39.5792 92.1772 39.6486 92.1248 39.7196C92.058 39.8108 91.9919 39.9045 91.9257 39.9973C91.886 40.053 91.8457 40.1079 91.8066 40.1644C91.7007 40.3153 91.5961 40.4678 91.4915 40.6236C83.2703 52.8675 82.9111 74.2253 90.6912 88.3248C95.2644 96.613 101.632 100.549 107.773 99.8988ZM111.075 31.5928C111.072 31.5928 111.069 31.5936 111.066 31.5944C111.06 31.5944 111.053 31.596 111.047 31.5969C111.056 31.596 111.066 31.5944 111.075 31.5936V31.5928Z",
    stroke: "#771B00",
    strokeWidth: 2.51436,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.105 81.8821L84.182 87.2009L116.957 77.6105L126.057 65.9068C126.6 65.2079 126.494 64.0982 125.832 63.5633L116.58 56.0918L95.0712 58.087L78.7736 67.4593L71.6272 80.1226C71.2705 80.7548 71.5049 81.6177 72.1054 81.8821H72.105Z",
    fill: "#8BEFFF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.958 77.6095L126.707 65.0712C126.908 64.8119 126.869 64.3997 126.623 64.201L116.58 56.0908L111.084 66.5677L116.958 77.6091V77.6095Z",
    fill: "#00B8FF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1797 87.1982L116.956 77.6083L111.081 66.5664L87.1 73.4724L84.1797 87.1982Z",
    fill: "#57D3FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5989 82.0947L84.1824 87.1962L87.1028 73.4704L78.7737 67.4551L71.9209 79.5983C71.4147 80.4954 71.7472 81.7195 72.5993 82.0951L72.5989 82.0947Z",
    fill: "#00B8FF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6352 81.9667L107.344 112.361C107.444 112.446 107.557 112.279 107.466 112.181L84.1814 87.2012L71.7438 81.7235C71.6161 81.667 71.5242 81.8727 71.6352 81.9671V81.9667Z",
    fill: "#00518A"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.958 77.6113L84.1826 87.2017L106.895 111.568C107.742 112.477 109.098 112.004 109.397 110.694L116.958 77.6113Z",
    fill: "#1996DB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.52 65.3092L116.956 77.6109L109.429 110.543C109.364 110.83 109.707 110.975 109.808 110.704L126.747 65.4871C126.811 65.3176 126.626 65.1726 126.52 65.3088L126.52 65.3092Z",
    fill: "#006FB1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M106.551 56.8271L95.7148 70.9521L98.3112 70.2046L108.506 56.6455L106.551 56.8271Z",
    fill: "#D0FAFF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6467 57.6664L87.1021 73.4787L93.8668 71.5307L104.811 57.1875L99.6467 57.6664Z",
    fill: "#D0FAFF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.693 56.0822L95.5245 57.9528C95.2149 57.9815 94.9124 58.0788 94.6327 58.2395L79.3668 67.0185C78.9684 67.2477 78.628 67.5988 78.3815 68.036L72.2609 78.8815C71.5093 80.213 71.7838 82.0138 72.8805 82.947L106.267 111.364C107.538 112.447 109.325 111.87 109.961 110.171L126.225 66.7549C126.717 65.4428 126.347 63.9001 125.348 63.0933L117.288 56.5847C116.82 56.2063 116.257 56.0289 115.693 56.0813L115.693 56.0822Z",
    stroke: "#002E41",
    strokeWidth: 1.33962,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M116.958 77.6143L84.1612 86.6892L74.4243 82.9066L84.1826 87.2042L116.958 77.6143Z",
    fill: "#D0FAFF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M84.1836 87.206L103.984 108.448L84.7751 87.0332L84.1836 87.206Z",
    fill: "#D0FAFF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M117.206 77.4521L109.974 107.977L116.628 77.6805L117.206 77.4521Z",
    fill: "#D0FAFF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1029 73.4775L84.1611 86.6883L84.6405 86.6355L87.1029 73.4775Z",
    fill: "#D0FAFF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M111.084 66.5732L116.775 77.8263L117.207 77.4539L111.084 66.5732Z",
    fill: "#D0FAFF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M137.331 90.7532L140.688 91.5146L134.613 79.5205L133.817 83.8134L137.331 90.7532Z",
    fill: "#006FB1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M135.062 105.144L136.674 109.244C136.946 109.935 137.803 109.805 137.922 109.056L140.688 91.5153L137.332 90.7539L135.062 105.145L135.062 105.144Z",
    fill: "#00518A"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M114.312 111.068L110.625 113.444L126.781 119.196L130.468 116.82L114.312 111.068Z",
    fill: "#00518A"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M111.382 79.1338L107.694 81.5097L104.55 101.448L108.237 99.0736L111.382 79.1338Z",
    fill: "#00A7E5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M110.625 113.442L104.55 101.448L108.237 99.0732L114.312 111.066L110.625 113.442Z",
    fill: "#006FB1"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 83.8153L134.615 79.5224L118.459 73.7715L122.157 79.6641L133.818 83.8153Z",
    fill: "#D0FAFF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M129.847 108.982L128.532 118.083L135.7 112.813C136.751 112.04 137.148 110.455 136.625 109.124L135.061 105.148L129.847 108.981L129.847 108.982Z",
    fill: "#006FB1"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M122.156 79.6641L118.458 73.7715L109.446 80.3954L116.942 83.4971L122.156 79.6641Z",
    fill: "#00B8FF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M118.188 104.829L112.377 112.33L128.534 118.081L129.849 108.98L118.188 104.829Z",
    fill: "#009BD2"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M116.943 83.4962L109.447 80.3945L106.302 100.334L114.673 97.8871L116.943 83.4962Z",
    fill: "#57D3FF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M122.156 79.665L116.943 83.498L114.673 97.8889L118.187 104.829L129.849 108.98L135.063 105.147L137.332 90.756L133.818 83.8162L122.156 79.665Z",
    fill: "#8BEFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.594 80.8809L133.817 83.8084L134.296 84.7551L114.851 96.7492L116.465 86.5109L125.594 80.8809Z",
    fill: "#D0FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.085 92.2998L136.048 98.8848L123.407 106.681L118.186 104.822L117.852 104.162L137.085 92.2998Z",
    fill: "#D0FAFF"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M114.673 97.8887L106.302 100.336L112.377 112.329L118.187 104.828L114.673 97.8887Z",
    fill: "#00B8FF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M129.856 116.765L134.573 113.297C136.17 112.123 137.277 110.203 137.623 108.009L139.968 93.1424C140.133 92.0943 139.969 91.011 139.507 90.0976L135.019 81.2367C134.46 80.1326 133.575 79.3165 132.537 78.9469L119.79 74.4095C118.646 74.0024 117.412 74.189 116.39 74.9236L108.695 80.4563C107.762 81.1265 107.115 82.2376 106.914 83.5108L104.383 99.5602C104.191 100.776 104.382 102.034 104.918 103.094L109.367 111.878C109.877 112.885 110.684 113.63 111.631 113.966L124.97 118.715C125.832 119.021 126.761 118.907 127.551 118.398L129.856 116.766L129.856 116.765Z",
    stroke: "#002E41",
    strokeWidth: 1.33962,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M116.942 83.4961L114.31 97.9926L118.186 104.827L114.672 97.887L116.942 83.4961Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M114.311 97.9961L106.302 100.338L114.577 98.4643L114.311 97.9961Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2595 76.5905C87.2595 73.2559 87.05 73.0067 84.2461 73.0067C87.05 73.0067 87.2595 72.7575 87.2595 69.4229C87.2595 72.7575 87.469 73.0067 90.2729 73.0067C87.469 73.0067 87.2595 73.2559 87.2595 76.5905Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M116.941 86.6481C116.941 83.3135 116.732 83.0643 113.928 83.0643C116.732 83.0643 116.941 82.8151 116.941 79.4805C116.941 82.8151 117.151 83.0643 119.955 83.0643C117.151 83.0643 116.941 83.3135 116.941 86.6481Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.796 34.8099L128.873 40.1286L161.649 30.5383L170.749 18.8345C171.292 18.1356 171.185 17.026 170.523 16.491L161.271 9.01953L139.763 11.0148L123.465 20.387L116.319 33.0504C115.962 33.6826 116.196 34.5454 116.797 34.8099H116.796Z",
    fill: "#8BEFFF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.649 30.5373L171.398 17.999C171.599 17.7396 171.56 17.3274 171.314 17.1287L161.271 9.01855L155.775 19.4954L161.649 30.5368V30.5373Z",
    fill: "#00B8FF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.871 40.1259L161.647 30.536L155.773 19.4941L131.791 26.4001L128.871 40.1259Z",
    fill: "#57D3FF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.29 35.0224L128.874 40.124L131.794 26.3982L123.465 20.3828L116.612 32.5261C116.106 33.4232 116.439 34.6473 117.291 35.0229L117.29 35.0224Z",
    fill: "#00B8FF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.327 34.8954L152.036 65.2899C152.135 65.3746 152.248 65.2079 152.157 65.1102L128.873 40.1299L116.435 34.6522C116.307 34.5957 116.216 34.8014 116.327 34.8959V34.8954Z",
    fill: "#00518A"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.649 30.5391L128.874 40.1294L151.586 64.496C152.434 65.4052 153.79 64.9314 154.089 63.6216L161.649 30.5391Z",
    fill: "#1996DB"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.211 18.237L161.647 30.5386L154.121 63.4711C154.055 63.7573 154.398 63.9028 154.5 63.6318L171.439 18.4148C171.502 18.2453 171.318 18.1003 171.212 18.2365L171.211 18.237Z",
    fill: "#006FB1"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M151.242 9.7548L140.406 23.8798L143.003 23.1323L153.197 9.57324L151.242 9.7548Z",
    fill: "#D0FAFF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M144.338 10.5941L131.793 26.4064L138.558 24.4584L149.502 10.1152L144.338 10.5941Z",
    fill: "#D0FAFF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.384 9.00991L140.216 10.8806C139.906 10.9093 139.604 11.0065 139.324 11.1673L124.058 19.9462C123.66 20.1755 123.319 20.5265 123.073 20.9637L116.952 31.8092C116.201 33.1408 116.475 34.9415 117.572 35.8747L150.958 64.292C152.23 65.3744 154.016 64.7973 154.653 63.0985L170.917 19.6827C171.408 18.3706 171.039 16.8278 170.04 16.021L161.98 9.51243C161.511 9.13404 160.949 8.95665 160.384 9.00899L160.384 9.00991Z",
    stroke: "#002E41",
    strokeWidth: 1.33962,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M161.65 30.542L128.853 39.6169L119.116 35.8344L128.874 40.1319L161.65 30.542Z",
    fill: "#D0FAFF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M128.875 40.1337L148.675 61.3759L129.467 39.9609L128.875 40.1337Z",
    fill: "#D0FAFF"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M161.898 30.3799L154.665 60.9045L161.32 30.6082L161.898 30.3799Z",
    fill: "#D0FAFF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M131.795 26.4053L128.853 39.6161L129.332 39.5633L131.795 26.4053Z",
    fill: "#D0FAFF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M155.776 19.501L161.467 30.7541L161.898 30.3817L155.776 19.501Z",
    fill: "#D0FAFF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M182.023 43.68L185.379 44.4414L179.305 32.4473L178.508 36.7402L182.023 43.68Z",
    fill: "#006FB1"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M179.752 58.0701L181.365 62.1694C181.637 62.8609 182.494 62.7312 182.613 61.9814L185.379 44.4411L182.023 43.6797L179.753 58.0706L179.752 58.0701Z",
    fill: "#00518A"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M159.003 63.9951L155.316 66.3711L171.473 72.1224L175.16 69.7465L159.003 63.9951Z",
    fill: "#00518A"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M156.073 32.0605L152.386 34.4365L149.241 54.3749L152.928 52.0004L156.073 32.0605Z",
    fill: "#00A7E5"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M155.316 66.3691L149.241 54.3745L152.928 52L159.003 63.9932L155.316 66.3691Z",
    fill: "#006FB1"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M178.51 36.742L179.306 32.4491L163.15 26.6982L166.848 32.5909L178.51 36.742Z",
    fill: "#D0FAFF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M174.538 61.9087L173.223 71.0095L180.391 65.7393C181.442 64.9668 181.839 63.3815 181.316 62.0508L179.752 58.0752L174.539 61.9082L174.538 61.9087Z",
    fill: "#006FB1"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M166.847 32.5909L163.149 26.6982L154.138 33.3222L161.634 36.4239L166.847 32.5909Z",
    fill: "#00B8FF"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M162.879 57.7559L157.069 65.2565L173.225 71.0079L174.541 61.907L162.879 57.7559Z",
    fill: "#009BD2"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M161.634 36.423L154.138 33.3213L150.993 53.2611L159.364 50.8139L161.634 36.423Z",
    fill: "#57D3FF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M166.847 32.5918L161.634 36.4248L159.364 50.8157L162.878 57.7555L174.54 61.9067L179.753 58.0737L182.023 43.6828L178.509 36.743L166.847 32.5918Z",
    fill: "#8BEFFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.285 33.8076L178.509 36.7352L178.988 37.6818L159.542 49.676L161.157 39.4376L170.285 33.8076Z",
    fill: "#D0FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.777 45.2266L180.74 51.8116L168.099 59.6077L162.878 57.7487L162.543 57.0891L181.777 45.2266Z",
    fill: "#D0FAFF"
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M159.364 50.8154L150.993 53.2627L157.069 65.2559L162.879 57.7552L159.364 50.8154Z",
    fill: "#00B8FF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M174.547 69.6919L179.264 66.2239C180.861 65.0498 181.968 63.1301 182.315 60.9357L184.659 46.0691C184.825 45.021 184.661 43.9377 184.198 43.0244L179.71 34.1635C179.151 33.0593 178.266 32.2433 177.228 31.8737L164.481 27.3362C163.338 26.9291 162.103 27.1158 161.082 27.8503L153.386 33.3831C152.454 34.0532 151.806 35.1643 151.606 36.4375L149.074 52.4869C148.882 53.7032 149.073 54.9606 149.61 56.0207L154.059 64.8048C154.568 65.8117 155.376 66.5564 156.322 66.8931L169.661 71.6413C170.523 71.9479 171.452 71.834 172.243 71.3245L174.548 69.6924L174.547 69.6919Z",
    stroke: "#002E41",
    strokeWidth: 1.33962,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M161.633 36.4229L159.001 50.9193L162.878 57.7535L159.363 50.8137L161.633 36.4229Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M159.003 50.9229L150.994 53.2645L159.268 51.3911L159.003 50.9229Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M131.951 29.5182C131.951 26.1836 131.741 25.9344 128.938 25.9344C131.741 25.9344 131.951 25.6852 131.951 22.3506C131.951 25.6852 132.16 25.9344 134.964 25.9344C132.16 25.9344 131.951 26.1836 131.951 29.5182Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M161.633 39.5759C161.633 36.2412 161.423 35.992 158.619 35.992C161.423 35.992 161.633 35.7429 161.633 32.4082C161.633 35.7429 161.842 35.992 164.646 35.992C161.842 35.992 161.633 36.2412 161.633 39.5759Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M219.96 87.9189C220.02 79.0626 206.715 71.7338 190.242 71.5497C173.768 71.3655 160.365 78.3958 160.305 87.2522C160.245 96.1086 173.55 103.437 190.023 103.621C206.496 103.806 219.899 96.7753 219.96 87.9189Z",
    fill: "#FF7C00"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M220.031 75.9408L160.416 75.2744L160.331 87.7043L219.946 88.3706L220.031 75.9408Z",
    fill: "#FF7C00"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M160.288 75.2803L160.206 87.3676C160.206 87.3676 159.845 94.7664 171.276 99.8528L171.73 86.8567C171.73 86.8567 162.143 82.3611 160.288 75.2811L160.288 75.2803Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_424_207912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 160,
    y: 71,
    width: 60,
    height: 33
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M219.862 88.0106C219.925 79.1542 206.621 71.8301 190.148 71.6517C173.674 71.4733 160.27 78.5081 160.207 87.3645C160.145 96.2209 173.449 103.545 189.922 103.723C206.395 103.902 219.8 96.867 219.862 88.0106Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_424_207912)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M194.313 78.6299L187.319 78.5518L187.128 106.583L194.122 106.661L194.313 78.6299Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M213.334 78.4293L196.847 78.2461L196.655 106.277L213.142 106.46L213.334 78.4293Z",
    fill: "white"
  })))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M220.021 75.9414C220.078 67.5009 206.753 60.509 190.257 60.3247C173.761 60.1403 160.342 66.8332 160.284 75.2737C160.227 83.7142 173.553 90.7061 190.048 90.8905C206.544 91.0749 219.963 84.3819 220.021 75.9414Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M190.27 90.1589C173.964 89.9757 160.756 83.1403 160.51 74.8311C160.502 74.9747 160.497 75.1192 160.495 75.2645C160.437 83.7053 173.763 90.6981 190.259 90.8829C206.755 91.0685 220.174 84.376 220.232 75.936C220.232 75.8391 220.23 75.7423 220.228 75.6454C219.723 83.8804 206.483 90.3413 190.27 90.1589Z",
    fill: "url(#paint14_linear_424_207912)"
  }), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M211.137 75.0145C211.173 69.6229 201.842 65.1474 190.294 65.0184C178.746 64.8893 169.354 69.1554 169.317 74.5471C169.281 79.9388 178.612 84.4142 190.16 84.5433C201.709 84.6724 211.1 80.4062 211.137 75.0145Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M190.233 64.9948C201.484 65.1215 210.631 69.3741 211.058 74.5792C211.071 74.4428 211.08 74.3056 211.081 74.1668C211.118 68.7753 201.786 64.2998 190.238 64.1699C178.69 64.0399 169.299 68.3055 169.262 73.697C169.261 73.8351 169.268 73.9731 169.279 74.1095C169.778 68.9149 178.98 64.868 190.233 64.9948Z",
    fill: "url(#paint15_linear_424_207912)"
  }), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M190.365 66.3971C201.137 66.5182 209.979 70.4214 211.089 75.3214C211.096 75.2213 211.101 75.1212 211.102 75.0203C211.139 69.6288 201.807 65.1533 190.259 65.0234C178.711 64.8935 169.32 69.159 169.283 74.5506C169.28 74.913 169.321 75.2705 169.401 75.624C169.778 70.3762 179.033 66.2704 190.365 66.3979L190.365 66.3971Z",
    fill: "#CB6300"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M187.83 68.0789L183.048 68.0547L183.034 72.7472L187.816 72.7715L187.83 68.0789ZM187.83 68.0789L183.048 68.0547L183.034 72.7472L187.816 72.7715L187.83 68.0789ZM187.801 77.4664L183.019 77.4422L183.005 82.1348L187.787 82.159L187.801 77.4664ZM187.801 77.4664L183.019 77.4422L183.005 82.1348L187.787 82.159L187.801 77.4664ZM187.817 72.7715L187.803 77.464L192.585 77.4882L192.57 82.1824L197.352 82.2066L197.366 77.5124L197.381 72.8199L192.599 72.7957L187.817 72.7715ZM187.817 72.7715L187.803 77.464L192.585 77.4882L192.57 82.1824L197.352 82.2066L197.366 77.5124L197.381 72.8199L192.599 72.7957L187.817 72.7715Z",
    fill: "#C15900"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M220.129 75.9396H220.125C220.182 67.4988 206.857 60.506 190.361 60.3212C173.865 60.1355 160.445 66.8281 160.388 75.2681C160.385 75.7435 160.425 76.214 160.504 76.6789L160.441 85.884C160.355 86.3683 160.31 86.859 160.307 87.3554C160.246 96.2118 173.551 103.541 190.024 103.727C201.907 103.861 212.192 100.24 217.024 94.8882C218.953 92.7937 220.043 90.4289 220.06 87.918C220.061 87.7606 220.058 87.6032 220.05 87.4474L220.129 75.9404V75.9396Z",
    stroke: "#771B00",
    strokeWidth: 2.51436,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M220.419 71.9209C220.48 63.0645 207.174 55.7357 190.701 55.5516C174.228 55.3675 160.825 62.3977 160.765 71.2541C160.704 80.1105 174.009 87.4393 190.483 87.6234C206.956 87.8076 220.359 80.7773 220.419 71.9209Z",
    fill: "#FF7C00"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M220.494 59.9456L160.878 59.2793L160.794 71.7092L220.409 72.3755L220.494 59.9456Z",
    fill: "#FF7C00"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M160.75 59.2793L160.668 71.3666C160.668 71.3666 160.307 78.7654 171.738 83.8518L172.192 70.8557C172.192 70.8557 162.605 66.3601 160.75 59.2801L160.75 59.2793Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_424_207912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 160,
    y: 55,
    width: 61,
    height: 33
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M220.327 72.0116C220.389 63.1552 207.086 55.8311 190.613 55.6526C174.139 55.4742 160.735 62.5091 160.672 71.3655C160.61 80.2219 173.914 87.546 190.387 87.7244C206.86 87.9028 220.265 80.8679 220.327 72.0116Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_424_207912)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M194.778 62.6377L187.785 62.5596L187.594 90.5903L194.587 90.6685L194.778 62.6377Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M213.799 62.4361L197.312 62.2529L197.119 90.2837L213.607 90.4669L213.799 62.4361Z",
    fill: "white"
  })))), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M220.487 59.9463C220.544 51.5058 207.218 44.5139 190.723 44.3296C174.227 44.1452 160.808 50.8381 160.75 59.2786C160.693 67.7191 174.018 74.711 190.514 74.8954C207.01 75.0797 220.429 68.3868 220.487 59.9463Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M190.733 74.1638C174.426 73.9806 161.219 67.1452 160.973 58.8359C160.964 58.9796 160.959 59.1241 160.958 59.2694C160.9 67.7101 174.225 74.703 190.721 74.8878C207.217 75.0734 220.637 68.3809 220.694 59.9409C220.695 59.844 220.693 59.7472 220.69 59.6503C220.186 67.8853 206.945 74.3462 190.733 74.1638Z",
    fill: "url(#paint16_linear_424_207912)"
  }), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M211.601 59.0204C211.638 53.6287 202.306 49.1533 190.758 49.0242C179.21 48.8951 169.819 53.1613 169.782 58.553C169.746 63.9446 179.077 68.4201 190.625 68.5491C202.173 68.6782 211.565 64.412 211.601 59.0204Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M190.699 48.9967C201.95 49.1234 211.096 53.3761 211.524 58.5812C211.537 58.4448 211.546 58.3076 211.546 58.1687C211.584 52.7772 202.252 48.3018 190.704 48.1718C179.156 48.0419 169.765 52.3075 169.728 57.699C169.726 57.837 169.733 57.975 169.745 58.1114C170.244 52.9169 179.446 48.87 190.699 48.9967Z",
    fill: "url(#paint17_linear_424_207912)"
  }), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M190.827 50.3981C201.599 50.5191 210.441 54.4223 211.551 59.3223C211.558 59.2222 211.563 59.1222 211.563 59.0213C211.601 53.6298 202.269 49.1543 190.721 49.0244C179.173 48.8944 169.782 53.16 169.745 58.5515C169.742 58.9139 169.783 59.2715 169.863 59.625C170.24 54.3771 179.495 50.2714 190.826 50.3989L190.827 50.3981Z",
    fill: "#CB6300"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M188.291 52.0828L183.509 52.0586L183.494 56.7511L188.276 56.7754L188.291 52.0828ZM188.291 52.0828L183.509 52.0586L183.494 56.7511L188.276 56.7754L188.291 52.0828ZM188.262 61.4703L183.48 61.4461L183.465 66.1387L188.247 66.1629L188.262 61.4703ZM188.262 61.4703L183.48 61.4461L183.465 66.1387L188.247 66.1629L188.262 61.4703ZM188.278 56.7754L188.263 61.4679L193.045 61.4921L193.031 66.1863L197.812 66.2105L197.827 61.5163L197.841 56.8238L193.06 56.7996L188.278 56.7754ZM188.278 56.7754L188.263 61.4679L193.045 61.4921L193.031 66.1863L197.812 66.2105L197.827 61.5163L197.841 56.8238L193.06 56.7996L188.278 56.7754Z",
    fill: "#C15900"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M220.588 59.9464H220.584C220.642 51.5056 207.316 44.5128 190.82 44.328C174.324 44.1424 160.905 50.8349 160.848 59.2749C160.844 59.7503 160.884 60.2208 160.964 60.6857L160.901 69.8909C160.815 70.3751 160.769 70.8659 160.766 71.3622C160.706 80.2187 174.011 87.5481 190.484 87.7337C202.366 87.8677 212.651 84.247 217.484 78.895C219.413 76.8006 220.503 74.4357 220.52 71.9248C220.521 71.7674 220.517 71.61 220.51 71.4542L220.588 59.9472V59.9464Z",
    stroke: "#771B00",
    strokeWidth: 2.51436,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M227.424 55.7354C227.484 46.879 214.179 39.5502 197.706 39.3661C181.232 39.1819 167.829 46.2122 167.769 55.0686C167.709 63.925 181.014 71.2538 197.487 71.4379C213.96 71.622 227.363 64.5918 227.424 55.7354Z",
    fill: "#FF7C00"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M227.498 43.7572L167.883 43.0908L167.798 55.5207L227.414 56.187L227.498 43.7572Z",
    fill: "#FF7C00"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M167.758 43.0908L167.677 55.1781C167.677 55.1781 167.315 62.5769 178.746 67.6634L179.2 54.6672C179.2 54.6672 169.613 50.1716 167.758 43.0916L167.758 43.0908Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_424_207912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 39,
    width: 61,
    height: 33
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M227.333 55.827C227.395 46.9706 214.091 39.6465 197.618 39.4681C181.145 39.2897 167.74 46.3246 167.678 55.1809C167.615 64.0373 180.919 71.3614 197.392 71.5398C213.866 71.7182 227.27 64.6834 227.333 55.827Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_424_207912)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M201.778 46.4493L194.785 46.3711L194.594 74.4019L201.587 74.48L201.778 46.4493Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M220.8 46.2486L204.312 46.0654L204.12 74.0962L220.608 74.2794L220.8 46.2486Z",
    fill: "white"
  })))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M227.487 43.7578C227.545 35.3173 214.219 28.3255 197.723 28.1411C181.227 27.9567 167.808 34.6496 167.751 43.0901C167.693 51.5306 181.019 58.5225 197.515 58.7069C214.011 58.8913 227.43 52.1983 227.487 43.7578Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M197.737 57.9753C181.43 57.7921 168.223 50.9567 167.977 42.6475C167.968 42.7911 167.963 42.9356 167.962 43.0809C167.904 51.5217 181.229 58.5145 197.725 58.6993C214.221 58.885 227.641 52.1924 227.698 43.7524C227.699 43.6555 227.697 43.5587 227.694 43.4618C227.189 51.6968 213.949 58.1577 197.737 57.9753Z",
    fill: "url(#paint18_linear_424_207912)"
  }), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M218.604 42.8319C218.641 37.4403 209.309 32.9648 197.761 32.8357C186.213 32.7067 176.822 36.9728 176.785 42.3645C176.749 47.7562 186.08 52.2316 197.628 52.3607C209.176 52.4897 218.568 48.2236 218.604 42.8319Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M197.697 32.8121C208.949 32.9389 218.095 37.1915 218.522 42.3966C218.536 42.2602 218.544 42.123 218.545 41.9842C218.582 36.5927 209.251 32.1172 197.703 31.9873C186.155 31.8573 176.763 36.1229 176.726 41.5144C176.725 41.6524 176.732 41.7905 176.743 41.9269C177.242 36.7323 186.445 32.6854 197.697 32.8121Z",
    fill: "url(#paint19_linear_424_207912)"
  }), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M197.835 34.2106C208.608 34.3316 217.449 38.2348 218.559 43.1348C218.566 43.0347 218.571 42.9347 218.572 42.8338C218.609 37.4423 209.277 32.9668 197.73 32.8369C186.182 32.7069 176.79 36.9725 176.753 42.364C176.751 42.7264 176.791 43.084 176.872 43.4375C177.248 38.1896 186.503 34.0839 197.835 34.2114L197.835 34.2106Z",
    fill: "#CB6300"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M195.297 35.8963L190.516 35.8721L190.501 40.5646L195.283 40.5888L195.297 35.8963ZM195.297 35.8963L190.516 35.8721L190.501 40.5646L195.283 40.5888L195.297 35.8963ZM195.268 45.2838L190.487 45.2596L190.472 49.9522L195.254 49.9764L195.268 45.2838ZM195.268 45.2838L190.487 45.2596L190.472 49.9522L195.254 49.9764L195.268 45.2838ZM195.285 40.5888L195.27 45.2814L200.052 45.3056L200.038 49.9998L204.819 50.024L204.834 45.3298L204.848 40.6373L200.067 40.6131L195.285 40.5888ZM195.285 40.5888L195.27 45.2814L200.052 45.3056L200.038 49.9998L204.819 50.024L204.834 45.3298L204.848 40.6373L200.067 40.6131L195.285 40.5888Z",
    fill: "#C15900"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M227.595 43.7619H227.59C227.648 35.3211 214.323 28.3282 197.827 28.1434C181.331 27.9578 167.911 34.6504 167.854 43.0903C167.851 43.5657 167.891 44.0363 167.97 44.5012L167.907 53.7063C167.821 54.1906 167.776 54.6813 167.773 55.1777C167.712 64.0341 181.017 71.3635 197.49 71.5491C209.373 71.6831 219.658 68.0624 224.49 62.7104C226.419 60.616 227.509 58.2511 227.526 55.7402C227.527 55.5828 227.524 55.4254 227.516 55.2697L227.595 43.7627V43.7619Z",
    stroke: "#771B00",
    strokeWidth: 2.51436,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M222.394 40.1465C222.454 31.2901 209.149 23.9613 192.676 23.7772C176.203 23.5931 162.799 30.6233 162.739 39.4797C162.679 48.3361 175.984 55.6649 192.457 55.849C208.93 56.0331 222.333 49.0029 222.394 40.1465Z",
    fill: "#FF7C00"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M222.466 28.1683L162.851 27.502L162.766 39.9318L222.382 40.5982L222.466 28.1683Z",
    fill: "#FF7C00"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M162.725 27.502L162.644 39.5893C162.644 39.5893 162.283 46.9881 173.713 52.0745L174.168 39.0784C174.168 39.0784 164.58 34.5828 162.726 27.5028L162.725 27.502Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_424_207912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 23,
    width: 61,
    height: 33
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M222.296 40.2264C222.359 31.37 209.055 24.0459 192.582 23.8675C176.109 23.6891 162.704 30.724 162.642 39.5803C162.579 48.4367 175.883 55.7608 192.356 55.9392C208.829 56.1177 222.234 49.0828 222.296 40.2264Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_424_207912)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M196.743 30.8526L189.75 30.7744L189.559 58.8052L196.552 58.8833L196.743 30.8526Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M215.766 30.651L199.279 30.4678L199.087 58.4985L215.574 58.6817L215.766 30.651Z",
    fill: "white"
  })))), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M222.456 28.1699C222.513 19.7294 209.187 12.7376 192.691 12.5532C176.196 12.3688 162.776 19.0617 162.719 27.5023C162.661 35.9428 175.987 42.9346 192.483 43.119C208.979 43.3034 222.398 36.6105 222.456 28.1699Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M192.703 42.3826C176.397 42.1994 163.189 35.3639 162.944 27.0547C162.935 27.1984 162.93 27.3428 162.928 27.4881C162.87 35.9289 176.196 42.9217 192.692 43.1065C209.188 43.2922 222.607 36.5996 222.665 28.1596C222.665 28.0628 222.664 27.9659 222.661 27.8691C222.156 36.104 208.916 42.565 192.703 42.3826Z",
    fill: "url(#paint20_linear_424_207912)"
  }), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M213.574 27.2401C213.611 21.8484 204.279 17.373 192.731 17.2439C181.183 17.1149 171.792 21.381 171.755 26.7727C171.718 32.1643 181.05 36.6398 192.598 36.7689C204.146 36.8979 213.537 32.6318 213.574 27.2401Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M192.668 17.2233C203.919 17.35 213.066 21.6027 213.493 26.8077C213.506 26.6713 213.515 26.5341 213.516 26.3953C213.553 21.0038 204.221 16.5283 192.673 16.3984C181.126 16.2685 171.734 20.534 171.697 25.9256C171.696 26.0636 171.703 26.2016 171.714 26.338C172.213 21.1434 181.415 17.0966 192.668 17.2233Z",
    fill: "url(#paint21_linear_424_207912)"
  }), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M192.802 18.6188C203.574 18.7399 212.416 22.643 213.526 27.543C213.533 27.4429 213.538 27.3429 213.539 27.242C213.576 21.8505 204.244 17.375 192.696 17.2451C181.148 17.1151 171.757 21.3807 171.72 26.7722C171.717 27.1346 171.758 27.4922 171.838 27.8457C172.215 22.5979 181.47 18.4921 192.802 18.6196L192.802 18.6188Z",
    fill: "#CB6300"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M190.387 19.8943L184.669 19.8652L184.655 24.5578L190.373 24.5868L190.387 19.8943ZM190.387 19.8943L184.669 19.8652L184.655 24.5578L190.373 24.5868L190.387 19.8943ZM190.358 29.2818L184.64 29.2528L184.626 33.9453L190.344 33.9744L190.358 29.2818ZM190.358 29.2818L184.64 29.2528L184.626 33.9453L190.344 33.9744L190.358 29.2818ZM190.375 24.5868L190.361 29.2794L196.078 29.3085L196.064 34.0026L201.781 34.0317L201.796 29.3375L201.81 24.645L196.093 24.6159L190.375 24.5868ZM190.375 24.5868L190.361 29.2794L196.078 29.3085L196.064 34.0026L201.781 34.0317L201.796 29.3375L201.81 24.645L196.093 24.6159L190.375 24.5868Z",
    fill: "#C15900"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M222.565 28.1681H222.561C222.619 19.7273 209.293 12.7345 192.797 12.5497C176.301 12.364 162.882 19.0566 162.825 27.4966C162.822 27.972 162.861 28.4425 162.941 28.9074L162.878 38.1125C162.792 38.5968 162.747 39.0875 162.743 39.5839C162.683 48.4404 175.988 55.7697 192.461 55.9554C204.343 56.0894 214.628 52.4687 219.461 47.1167C221.39 45.0222 222.48 42.6574 222.497 40.1465C222.498 39.9891 222.494 39.8317 222.487 39.6759L222.565 28.1689V28.1681Z",
    stroke: "#771B00",
    strokeWidth: 2.51436,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M189.846 103.479C189.906 94.6221 176.601 87.2933 160.128 87.1092C143.655 86.9251 130.252 93.9554 130.191 102.812C130.131 111.668 143.436 118.997 159.909 119.181C176.383 119.365 189.786 112.335 189.846 103.479Z",
    fill: "#FF7C00"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M189.919 91.5003L130.303 90.834L130.219 103.264L189.834 103.93L189.919 91.5003Z",
    fill: "#FF7C00"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M130.173 90.834L130.092 102.921C130.092 102.921 129.731 110.32 141.162 115.407L141.616 102.41C141.616 102.41 132.029 97.9148 130.174 90.8348L130.173 90.834Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_424_207912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 87,
    width: 60,
    height: 33
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M189.749 103.557C189.811 94.7011 176.507 87.377 160.034 87.1985C143.561 87.0201 130.156 94.055 130.094 102.911C130.031 111.768 143.335 119.092 159.808 119.27C176.282 119.449 189.686 112.414 189.749 103.557Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_424_207912)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M164.2 94.1885L157.207 94.1104L157.016 122.141L164.009 122.219L164.2 94.1885Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M183.222 93.9879L166.735 93.8047L166.543 121.835L183.03 122.019L183.222 93.9879Z",
    fill: "white"
  })))), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M189.91 91.4981C189.968 83.0576 176.642 76.0657 160.146 75.8813C143.65 75.6969 130.231 82.3899 130.173 90.8304C130.116 99.2709 143.442 106.263 159.938 106.447C176.433 106.632 189.853 99.9386 189.91 91.4981Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M160.157 105.721C143.851 105.538 130.643 98.7028 130.397 90.3936C130.388 90.5372 130.383 90.6817 130.382 90.827C130.324 99.2678 143.65 106.261 160.146 106.445C176.642 106.631 190.061 99.9385 190.118 91.4985C190.119 91.4016 190.117 91.3048 190.115 91.2079C189.61 99.4429 176.369 105.904 160.157 105.721Z",
    fill: "url(#paint22_linear_424_207912)"
  }), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M181.026 90.5721C181.063 85.1805 171.731 80.705 160.183 80.576C148.635 80.4469 139.244 84.7131 139.207 90.1047C139.17 95.4964 148.502 99.9718 160.05 100.101C171.598 100.23 180.989 95.9638 181.026 90.5721Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M160.119 80.5582C171.371 80.6849 180.517 84.9376 180.944 90.1427C180.957 90.0063 180.966 89.8691 180.967 89.7303C181.004 84.3387 171.672 79.8633 160.125 79.7334C148.577 79.6034 139.185 83.869 139.148 89.2605C139.147 89.3985 139.154 89.5365 139.165 89.673C139.664 84.4784 148.867 80.4315 160.119 80.5582Z",
    fill: "url(#paint23_linear_424_207912)"
  }), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M160.25 81.9537C171.022 82.0748 179.864 85.978 180.974 90.878C180.981 90.7779 180.986 90.6778 180.986 90.5769C181.024 85.1854 171.692 80.71 160.144 80.58C148.596 80.4501 139.205 84.7157 139.168 90.1072C139.165 90.4696 139.206 90.8271 139.286 91.1807C139.663 85.9328 148.918 81.827 160.249 81.9546L160.25 81.9537Z",
    fill: "#CB6300"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M157.839 83.2263L152.122 83.1973L152.107 87.8898L157.825 87.9189L157.839 83.2263ZM157.839 83.2263L152.122 83.1973L152.107 87.8898L157.825 87.9189L157.839 83.2263ZM157.81 92.6139L152.093 92.5848L152.078 97.2773L157.796 97.3064L157.81 92.6139ZM157.81 92.6139L152.093 92.5848L152.078 97.2773L157.796 97.3064L157.81 92.6139ZM157.827 87.9189L157.813 92.6114L163.53 92.6405L163.516 97.3347L169.233 97.3637L169.248 92.6695L169.262 87.977L163.545 87.9479L157.827 87.9189ZM157.827 87.9189L157.813 92.6114L163.53 92.6405L163.516 97.3347L169.233 97.3637L169.248 92.6695L169.262 87.977L163.545 87.9479L157.827 87.9189Z",
    fill: "#C15900"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M190.018 91.505H190.013C190.071 83.0642 176.746 76.0714 160.25 75.8866C143.754 75.7017 130.334 82.3935 130.277 90.8335C130.274 91.3089 130.313 91.7794 130.393 92.2443L130.33 101.449C130.244 101.934 130.199 102.424 130.196 102.921C130.135 111.777 143.44 119.107 159.913 119.292C171.796 119.426 182.081 115.806 186.913 110.454C188.842 108.359 189.932 105.994 189.949 103.483C189.95 103.326 189.946 103.169 189.939 103.013L190.018 91.5058V91.505Z",
    stroke: "#771B00",
    strokeWidth: 2.51436,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M181.054 87.5133C181.115 78.657 167.81 71.3291 151.337 71.1462C134.864 70.9632 121.46 77.9944 121.4 86.8508C121.339 95.7072 134.644 103.035 151.117 103.218C167.59 103.401 180.994 96.3697 181.054 87.5133Z",
    fill: "#FF7C00"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M181.13 75.5423L121.514 74.876L121.429 87.3058L181.045 87.9722L181.13 75.5423Z",
    fill: "#FF7C00"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M121.385 74.873L121.304 86.9604C121.304 86.9604 120.943 94.3592 132.374 99.4456L132.828 86.4495C132.828 86.4495 123.241 81.9538 121.386 74.8739L121.385 74.873Z",
    fill: "#EA6F00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_424_207912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 71,
    width: 60,
    height: 33
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M180.963 87.6073C181.025 78.7509 167.722 71.4268 151.248 71.2484C134.775 71.0699 121.37 78.1048 121.308 86.9612C121.246 95.8176 134.55 103.142 151.023 103.32C167.496 103.499 180.901 96.4636 180.963 87.6073Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_424_207912)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M155.413 78.2344L148.42 78.1562L148.229 106.187L155.222 106.265L155.413 78.2344Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M174.434 78.0328L157.947 77.8496L157.755 105.88L174.242 106.064L174.434 78.0328Z",
    fill: "white"
  })))), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M181.12 75.5401C181.177 67.0995 167.851 60.1077 151.355 59.9233C134.86 59.7389 121.44 66.4319 121.383 74.8724C121.325 83.3129 134.651 90.3047 151.147 90.4891C167.643 90.6735 181.062 83.9806 181.12 75.5401Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M151.365 89.7605C135.059 89.5773 121.851 82.7418 121.606 74.4326C121.597 74.5763 121.592 74.7208 121.591 74.866C121.533 83.3068 134.858 90.2996 151.354 90.4845C167.85 90.6701 181.27 83.9775 181.327 75.5376C181.328 75.4407 181.326 75.3438 181.323 75.247C180.818 83.482 167.578 89.9429 151.365 89.7605Z",
    fill: "url(#paint24_linear_424_207912)"
  }), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M172.237 74.6141C172.274 69.2225 162.942 64.747 151.394 64.618C139.846 64.4889 130.455 68.7551 130.418 74.1467C130.381 79.5384 139.713 84.0138 151.261 84.1429C162.809 84.272 172.2 80.0058 172.237 74.6141Z",
    fill: "#FF9600"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M151.33 64.5944C162.582 64.7211 171.728 68.9738 172.156 74.1788C172.169 74.0424 172.178 73.9052 172.178 73.7664C172.215 68.3749 162.884 63.8994 151.336 63.7695C139.788 63.6395 130.397 67.9051 130.36 73.2967C130.358 73.4347 130.365 73.5727 130.377 73.7091C130.876 68.5145 140.078 64.4676 151.33 64.5944Z",
    fill: "url(#paint25_linear_424_207912)"
  }), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M151.46 65.9928C162.233 66.1139 171.074 70.0171 172.184 74.9171C172.191 74.817 172.196 74.7169 172.197 74.616C172.234 69.2245 162.902 64.749 151.355 64.6191C139.807 64.4892 130.415 68.7547 130.378 74.1463C130.376 74.5087 130.416 74.8662 130.497 75.2197C130.873 69.9719 140.128 65.8661 151.46 65.9936L151.46 65.9928Z",
    fill: "#CB6300"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M149.048 67.2722L143.331 67.2432L143.316 71.9357L149.034 71.9648L149.048 67.2722ZM149.048 67.2722L143.331 67.2432L143.316 71.9357L149.034 71.9648L149.048 67.2722ZM149.019 76.6597L143.302 76.6307L143.287 81.3232L149.005 81.3523L149.019 76.6597ZM149.019 76.6597L143.302 76.6307L143.287 81.3232L149.005 81.3523L149.019 76.6597ZM149.036 71.9648L149.022 76.6573L154.739 76.6864L154.725 81.3806L160.442 81.4096L160.457 76.7154L160.471 72.0229L154.754 71.9938L149.036 71.9648ZM149.036 71.9648L149.022 76.6573L154.739 76.6864L154.725 81.3806L160.442 81.4096L160.457 76.7154L160.471 72.0229L154.754 71.9938L149.036 71.9648Z",
    fill: "#C15900"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M181.225 75.546H181.22C181.278 67.1053 167.953 60.1124 151.457 59.9276C134.961 59.742 121.541 66.4345 121.484 74.8745C121.481 75.3499 121.52 75.8205 121.6 76.2854L121.537 85.4905C121.451 85.9747 121.406 86.4655 121.403 86.9618C121.342 95.8183 134.647 103.148 151.12 103.333C163.003 103.467 173.288 99.8466 178.12 94.4946C180.049 92.4002 181.139 90.0353 181.156 87.5244C181.157 87.367 181.153 87.2096 181.146 87.0538L181.225 75.5468V75.546Z",
    stroke: "#771B00",
    strokeWidth: 2.51436,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M176.037 47.0302C176.037 40.395 175.65 39.8994 170.47 39.8994C175.65 39.8994 176.037 39.4038 176.037 32.7686C176.037 39.4038 176.424 39.8994 181.605 39.8994C176.424 39.8994 176.037 40.395 176.037 47.0302Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M234.553 110.543C231.986 110.815 229.419 111.087 226.853 111.359C220.711 112.01 214.344 108.074 209.771 99.7855C201.991 85.6852 202.35 64.3282 210.571 52.0843C213.96 47.0366 218.155 44.3256 222.462 43.8695L230.163 43.0527C225.856 43.5096 221.661 46.2198 218.272 51.2675C210.05 63.5138 209.692 84.8692 217.471 98.9695C222.044 107.259 228.411 111.195 234.553 110.543Z",
    fill: "#FF7C00"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M246.447 102.329C238.224 114.575 225.253 113.07 217.474 98.9702C209.694 84.8707 210.052 63.5145 218.274 51.2682C226.496 39.0235 239.468 40.5271 247.247 54.6274C255.027 68.7276 254.668 90.0847 246.447 102.329Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M242.721 94.7447C236.815 103.541 227.497 102.465 221.905 92.3314C216.317 82.203 216.574 66.8565 222.48 58.0598C228.389 49.2599 237.708 50.3438 243.296 60.4723C248.887 70.6064 248.629 85.9439 242.721 94.7447Z",
    fill: "url(#paint26_linear_424_207912)"
  }), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M242.481 95.141C236.574 103.938 227.255 102.863 221.664 92.7286C216.077 82.5993 216.333 67.2529 222.24 58.4561C228.149 49.6562 237.467 50.7401 243.056 60.8702C248.647 71.0027 248.389 86.3419 242.482 95.1418L242.481 95.141Z",
    fill: "#FF9600"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M241.106 62.0974C246.697 72.2307 246.439 87.5691 240.53 96.3698C239.491 97.9179 238.343 99.1544 237.131 100.095C239.066 99.1406 240.895 97.4998 242.478 95.1422C248.386 86.3423 248.644 71.0039 243.052 60.8706C238.448 52.5234 231.312 50.3257 225.636 54.7317C230.924 52.1223 237.013 54.6833 241.105 62.0982L241.106 62.0974Z",
    fill: "#CB6300"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M229.593 61.3154L224.001 61.7246L224.395 70.5464L229.987 70.1372L229.593 61.3154ZM229.593 61.3154L224.001 61.7246L224.395 70.5464L229.987 70.1372L229.593 61.3154ZM230.381 78.963L224.789 79.3722L225.183 88.1939L230.775 87.7847L230.381 78.963ZM230.381 78.963L224.789 79.3722L225.183 88.1939L230.775 87.7847L230.381 78.963ZM229.989 70.1364L230.383 78.9581L235.975 78.5489L236.369 87.3739L241.961 86.9647L241.567 78.1397L241.173 69.318L235.581 69.7272L229.989 70.1364ZM229.989 70.1364L230.383 78.9581L235.975 78.5489L236.369 87.3739L241.961 86.9647L241.567 78.1397L241.173 69.318L235.581 69.7272L229.989 70.1364Z",
    fill: "#C15900"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M217.06 99.0091C221.691 107.401 228.16 111.329 234.372 110.554C228.286 111.111 221.998 107.178 217.47 98.9696C209.69 84.8701 210.048 63.5139 218.27 51.2676C221.606 46.2998 225.723 43.6008 229.958 43.0811C229.868 43.0899 229.778 43.0932 229.688 43.102L229.512 43.1214C225.291 43.6517 221.187 46.3531 217.862 51.3072C209.639 63.5527 209.281 84.9081 217.061 99.0091H217.06Z",
    fill: "url(#paint27_linear_424_207912)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_424_207912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 204,
    y: 43,
    width: 30,
    height: 69
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M230.699 43.0371C228.127 43.2437 225.558 43.4512 222.987 43.657C216.836 44.1525 210.981 49.2285 207.393 58.277C201.289 73.6711 204.059 94.7367 213.578 105.328C217.502 109.693 221.959 111.598 226.272 111.25L233.984 110.63C229.671 110.977 225.214 109.073 221.289 104.708C211.769 94.1161 209.001 73.0512 215.104 57.6572C218.692 48.607 224.547 43.5319 230.698 43.0371H230.699Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_424_207912)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M230.486 64.1056L195.202 67.4639L196.316 86.6654L231.601 83.3071L230.486 64.1056Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.23
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M230.801 52.252L195.517 55.6104L196.008 64.0835L231.292 60.7252L230.801 52.252Z",
    fill: "white"
  })))), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M226.968 111.118C229.508 110.847 232.047 110.578 234.587 110.309C238.845 109.886 243 107.26 246.378 102.353C246.439 102.265 246.5 102.176 246.559 102.086C246.636 101.971 246.713 101.856 246.788 101.74C246.81 101.707 246.83 101.674 246.852 101.641C246.913 101.547 246.973 101.452 247.033 101.356C247.048 101.334 247.062 101.311 247.076 101.288C254.714 89.0575 254.969 68.6069 247.591 54.8101C247.588 54.8053 247.586 54.8004 247.583 54.7964C247.51 54.6584 247.435 54.5212 247.36 54.384C247.27 54.2217 247.18 54.0611 247.089 53.9021C247.073 53.8747 247.057 53.8464 247.041 53.819C246.948 53.6584 246.856 53.4994 246.762 53.3428C246.757 53.3355 246.753 53.3282 246.748 53.3202C243.044 47.1232 238.293 43.6066 233.466 42.8818L233.463 42.7656C232.398 42.6437 231.332 42.6598 230.273 42.8108L229.842 42.8568C229.83 42.8576 229.817 42.8584 229.805 42.86L229.629 42.8794C229.624 42.8794 229.619 42.881 229.613 42.8818L222.577 43.6284C219.575 43.9464 216.627 45.3612 213.968 47.8988C213.966 47.9012 213.964 47.9028 213.961 47.9053C213.85 48.011 213.74 48.1191 213.63 48.2289C213.62 48.2394 213.609 48.2499 213.599 48.2604C213.497 48.3629 213.395 48.467 213.293 48.5735C213.275 48.5921 213.257 48.6123 213.239 48.6309C213.145 48.7301 213.051 48.8302 212.958 48.9319C212.932 48.9602 212.907 48.9892 212.881 49.0175C212.796 49.1127 212.71 49.2079 212.625 49.3048C212.592 49.3419 212.56 49.3807 212.527 49.4186C212.45 49.509 212.371 49.5994 212.295 49.6914C212.255 49.739 212.215 49.7883 212.176 49.8359C212.106 49.9206 212.036 50.0054 211.967 50.0925C211.92 50.1515 211.873 50.212 211.826 50.2717C211.765 50.35 211.703 50.4283 211.642 50.5082C211.587 50.58 211.532 50.6543 211.477 50.7277C211.425 50.798 211.372 50.8674 211.32 50.9384C211.253 51.0296 211.187 51.1232 211.121 51.216C211.081 51.2717 211.041 51.3266 211.001 51.3831C210.896 51.534 210.791 51.6866 210.686 51.8424C202.465 64.0863 202.106 85.4441 209.886 99.5435C214.459 107.832 220.826 111.768 226.968 111.118ZM230.27 42.8116C230.267 42.8116 230.264 42.8124 230.261 42.8132C230.254 42.8132 230.248 42.8148 230.242 42.8156C230.251 42.8148 230.261 42.8132 230.27 42.8124V42.8116Z",
    stroke: "#771B00",
    strokeWidth: 2.51436,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_424_207912",
    x1: 41.2521,
    y1: 71.4673,
    x2: 100.991,
    y2: 71.8744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_424_207912",
    x1: 50.1008,
    y1: 57.8004,
    x2: 91.9211,
    y2: 58.0853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_424_207912",
    x1: 41.7138,
    y1: 55.4727,
    x2: 101.452,
    y2: 55.8797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_424_207912",
    x1: 50.5659,
    y1: 41.802,
    x2: 92.3862,
    y2: 42.0869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_424_207912",
    x1: 48.7169,
    y1: 39.2844,
    x2: 108.455,
    y2: 39.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_424_207912",
    x1: 57.5636,
    y1: 25.6176,
    x2: 99.3839,
    y2: 25.9025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_424_207912",
    x1: 43.6838,
    y1: 23.6913,
    x2: 103.422,
    y2: 24.0984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_424_207912",
    x1: 52.5344,
    y1: 10.0285,
    x2: 94.3541,
    y2: 10.3134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_424_207912",
    x1: 11.1394,
    y1: 87.032,
    x2: 70.8778,
    y2: 87.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_424_207912",
    x1: 19.9882,
    y1: 73.367,
    x2: 61.8085,
    y2: 73.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_424_207912",
    x1: 2.34727,
    y1: 71.0722,
    x2: 62.0857,
    y2: 71.4793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_424_207912",
    x1: 11.199,
    y1: 57.4025,
    x2: 53.0193,
    y2: 57.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_424_207912",
    x1: 104.179,
    y1: 42.4532,
    x2: 130.331,
    y2: 81.7899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_424_207912",
    x1: 100.093,
    y1: 36.5858,
    x2: 111.6,
    y2: 101.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_424_207912",
    x1: 160.447,
    y1: 82.6861,
    x2: 220.186,
    y2: 83.0931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_424_207912",
    x1: 169.296,
    y1: 69.0191,
    x2: 211.116,
    y2: 69.3041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_424_207912",
    x1: 160.909,
    y1: 66.6914,
    x2: 220.648,
    y2: 67.0985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_424_207912",
    x1: 169.761,
    y1: 53.0207,
    x2: 211.582,
    y2: 53.3057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_424_207912",
    x1: 167.913,
    y1: 50.5031,
    x2: 227.651,
    y2: 50.9102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_424_207912",
    x1: 176.759,
    y1: 36.8363,
    x2: 218.58,
    y2: 37.1213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_424_207912",
    x1: 162.879,
    y1: 34.9101,
    x2: 222.617,
    y2: 35.3171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_424_207912",
    x1: 171.73,
    y1: 21.2472,
    x2: 213.549,
    y2: 21.5322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_424_207912",
    x1: 130.335,
    y1: 98.2507,
    x2: 190.073,
    y2: 98.6578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_424_207912",
    x1: 139.184,
    y1: 84.5848,
    x2: 181.004,
    y2: 84.8697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_424_207912",
    x1: 121.543,
    y1: 82.291,
    x2: 181.281,
    y2: 82.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_424_207912",
    x1: 130.394,
    y1: 68.6213,
    x2: 172.215,
    y2: 68.9062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_424_207912",
    x1: 223.373,
    y1: 53.671,
    x2: 249.525,
    y2: 93.0077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_424_207912",
    x1: 219.288,
    y1: 47.8035,
    x2: 230.795,
    y2: 112.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperCoinGemStack);
export default __webpack_public_path__ + "static/media/hyper-coin-gem-stack.38c80059a7f7e3526e6dcebfd6911cdc.svg";
export { ForwardRef as ReactComponent };